module.exports = __webpack_public_path__ + "static/media/upload.94f95104.svg";